import React, { lazy } from 'react';
import { createRoot } from 'react-dom/client';
import type { IConsentBlockProps } from './consent-block';

const ConsentBlock = lazy(async () => import('./consent-block'));

const el = '.fa-component--consent-block';
const DOM = document.querySelectorAll(el);

const render = function () {
    if (DOM) {
        DOM.forEach((component) => {
            const props = JSON.parse(component.getAttribute('data-props')!) as IConsentBlockProps;

            createRoot(component).render(<ConsentBlock {...props} />);
        });
    }
};

export default {
    render,
};
